"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _DurationTrip = require("./DurationTrip");
var _default = exports["default"] = _DurationTrip.DurationTrip;